/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RansomwareCapabilitySpec { 
    /**
     * Enable/ Disable Carbon Black Check for Country Sanction
     */
    carbon_black_address_validation_enabled?: boolean;
    /**
     * Enable/ Disable Adding Plus Suffix To Contact Email Account In Carbon Black Org Provision Request.
     */
    contact_email_suffix_enabled?: boolean;
    /**
     * Enable/ Disable Ransomware
     */
    enabled?: boolean;
    /**
     * List of AWS regions supported for ransomware recovery deployment
     */
    enabled_aws_regions?: string;
    /**
     * List of Carbon Black regions supported for ransomware recovery deployment
     */
    enabled_carbon_black_pop_ids?: string;
    /**
     * List of all GCP regions supported for ransomware recovery
     */
    enabled_gcp_regions?: string;
    /**
     * Enable/ Disable Check for active IRR (VCDR Deployment) for allowing activating or de-activating RWR
     */
    requires_active_vcdr?: boolean;
    /**
     * Enable/ Disable Check if approval is required for de-activating RWR and automatically de-provisioning its CB PoP
     */
    requires_deactivation_approval?: boolean;
    /**
     * Enable/ Disable IRR reconfigure during RWR activation and deactivation
     */
    requires_irr_reconfigure?: boolean;
    /**
     * The ARN of the OVA to be used by IRR.
     */
    aws_ova_path?: string;
    /**
     * The GCP storage URI of the OVA to be used by IRR.
     */
    gcp_ova_path?: string;
}

